import React from 'react';
import Colortheme from '../Theme/Colortheme';
import { messyBorderStyle } from '../Utils/StyleUtils';
import BasicButton from './Button/BasicButton';

class TutorialCarousel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            index: 1
        }
        this.maxSteps = 3;
        this.pictureUrls = [];
        for (var i = 1; i <= this.maxSteps; i++) {
            this.pictureUrls.push(process.env.PUBLIC_URL + `/assets/tutorial/Tutorial_step${i}.jpg`);
        }

        this.style = {
            field: {
                ...messyBorderStyle("tutorial"),
                padding: '20px',
                margin: '10px',
                maxWidth: '550px',
                backgroundColor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
                WebkitBoxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`
            },
            rowSpaceBetween: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        };

        this.currentPicture = this.currentPicture.bind(this);
        this.next = this.next.bind(this);
        this.back = this.back.bind(this);
        this.isDone = this.isDone.bind(this);
    }

    componentDidMount() {
        // To preload all pictures
        this.pictureUrls.forEach((pictureUrl) => {
            const img = new Image();
            img.src = pictureUrl;
        });
    }

    next() {
        if (this.isDone()) {
            if (!this.props.location.state?.lobbyCode) {
                this.props.history.push({
                    pathname: `/home`,
                    state: this.props.location.state
                });
            } else {
                this.props.history.push({
                    pathname: `/lobby/${encodeURIComponent(this.props.location.state.lobbyCode)}`,
                    state: this.props.location.state
                });
            }
        }

        this.setState({
            index: this.state.index < this.maxSteps ? this.state.index + 1 : this.maxSteps
        });
    }

    back() {
        this.setState({
            index: this.state.index > 1 ? this.state.index - 1 : 1
        });
    }

    isDone() {
        return this.state.index == this.maxSteps;
    }

    currentPicture() {
        // Somehow the empty div makes the picture keep its aspect ratio on iOS
        return <div><img src={this.pictureUrls[this.state.index-1]} className="icon" style={{maxWidth: '100%'}}/></div>;
    }

    render() {
        return (
            <div style={this.style.field}>
                <h1 style={{ fontSize: 'max(calc(10px + 1.2vw), 20px)', margin: '0px' }}>How to play</h1>
                {this.currentPicture()}
                <div style={this.style.rowSpaceBetween}>
                    <BasicButton height={'50px'} onClick={() => this.back()}>Back</BasicButton>
                    {`Step ${this.state.index} of ${this.maxSteps}`}
                    <BasicButton height={'50px'} onClick={() => this.next()}>{this.isDone() ? 'Done' : 'Next'}</BasicButton>
                </div>
            </div>
        );
    }
}

export default TutorialCarousel;